const PARTNER_FIELDS = {
  ID: {api_name: 'id', required: false, label: 'id', display_label: 'id'},
  NAME: {api_name: 'name', required: true, label: 'Partner Name', display_label: 'Partner Name'},
  CONTACT_EMAIL: {api_name: 'contactEmail', required: true, label: 'Contact Email', display_label: 'Contact Email'},
  DESCRIPTION: {api_name: 'description', required: false, label: 'Purpose', display_label: 'Purpose'},
  STATUS: {api_name: 'status', required: false, label: 'Status', display_label: 'Status'},
  CLIENT_ID: {api_name: 'clientId', required: false, label: 'Client ID', display_label: 'Client ID'},
  SECRET_LAST_FOUR: {api_name: 'secretLastFour', required: false, label: 'Secret', display_label: 'Secret'},
  HAS_SECRET: {api_name: 'hasSecret', required: false, label: 'Has Secret', display_label: 'Has Secret'},
  PROFILE: {api_name: 'profile', required: false, label: 'Data Profile', display_label: 'Data Profile'},
  SCOPES: {api_name: 'scopes', required: false, label: 'Scopes', display_label: 'Scopes'},
  GRANT_COUNT: {api_name: 'grantCount', required: false, label: 'Companies', display_label: 'Companies'},
  COMPANY_COUNT: {api_name: 'companyCount', required: false, label: 'Effective Reach', display_label: 'Effective Reach'},
  LAST_USED: {api_name: 'lastUsedAt', required: false, label: 'Last Used', display_label: 'Last Used'},
  CREATED_AT: {api_name: 'createdAt', required: false, label: 'Created', display_label: 'Created'},
};

const PARTNER_STATUSES = {
  PENDING: {value: 'PENDING', label: 'Pending'},
  APPROVED: {value: 'APPROVED', label: 'Approved'},
  SUSPENDED: {value: 'SUSPENDED', label: 'Suspended'},
  REVOKED: {value: 'REVOKED', label: 'Revoked'},
};

/**
 * How much of a job the partner receives. Mirrors the backend `ReleaseProfile`
 * and is documented in docs/job-data-interface.md section 7.2.
 */
const PARTNER_PROFILES = {
  A: {
    value: 'A',
    label: 'A - Originating partner (full data)',
    hint: 'For the system that created these jobs and already holds the customer record.',
  },
  B: {
    value: 'B',
    label: 'B - Third party (masked)',
    hint: 'Permit tracking only. Homeowner name, phone and email are masked; street address, job value and fees are withheld. Notes are sent only if "Read notes" is granted.',
  },
};

const PARTNER_SCOPES = {
  JOBS_READ: {value: 'jobs:read', label: 'Read jobs'},
  JOBS_SEARCH: {value: 'jobs:search', label: 'Search jobs by address'},
  /**
   * The only scope that lets a partner write. Jobs it creates are always
   * drafts, so nothing is pulled or billed until someone submits them in the
   * portal - but grant it on purpose, not by habit.
   */
  JOBS_WRITE: {
    value: 'jobs:write',
    label: 'Create jobs (as drafts)',
    warn: true,
    hint: 'Lets this partner queue new jobs. They arrive as drafts for review and are not ordered until submitted.',
  },
  ATTACHMENTS_READ: {value: 'attachments:read', label: 'Read attachments'},
  COMPANIES_READ: {
    value: 'companies:read',
    label: 'List companies',
    hint: 'Lets this partner list the companies it can see, by id and name. Needed to make sense of the companyId on each job.',
  },
  NOTES_READ: {
    value: 'notes:read',
    label: 'Read notes',
    hint: 'Full note history on each job. Internal notes are never sent. Profile B sees the text, with iPermit staff shown as "iPermit".',
  },
  /**
   * Unlike jobs:write, nothing here is a draft: a note is visible to the
   * contractor, and copied to ServiceTitan, the moment it is written.
   */
  NOTES_WRITE: {
    value: 'notes:write',
    label: 'Add notes',
    warn: true,
    hint: 'Lets this partner post Permit, HERS, Inspection and Scheduling notes. They are live immediately.',
  },
};

export {PARTNER_FIELDS, PARTNER_STATUSES, PARTNER_PROFILES, PARTNER_SCOPES};
